<template>
    <section id="contato" style="padding-top: 120px">
        <div  class="section" >
            <div class="row">
                <div class="col s12 m6 center" >
                    <h5>Contact form:</h5>
                    <form class="col s12" >
                    <div class="row">
                        <div class="input-field col s12">
                            <input id="name"  type="text" class="validate" v-model="dados.name">
                            <label for="first_name">Name</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-field col s12">
                            <input id="email" type="email" class="validate" v-model="dados.email">
                            <label for="email">E-mail</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-field col s12">
                            <input id="mensagem" type="text" class="validate" v-model="dados.mensagem">
                            <label for="first_name">Message</label>
                        </div>
                    </div>
                    <div class="row">
                        <h6><a class="black-text" href="mailto:juscilan@gmail.com">If you prefer by e-mail: juscilan@gmail.com</a></h6>
                    </div>
                    <div class="row"> 
                        <button @click="enviar($event)" class="btn waves-effect waves-light" 
                            name="action">Send<i class="material-icons right">send</i>
                        </button>
                    </div>
                    </form>
                </div>
                <div class="col s12 m6 center" >
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import {scroll} from './common/jm-scroll'

export default {
  data () {
    return {
      titulo: '',
      mensagem: '',
      tipo: 'WARNING',
      inputvisible: false,
      senha: '',
      dados: {
        name: '',
        email: '',
        mensagem: ''
      }
    }
  },
  mounted () {
    scroll('scrollSoft')
  },
  methods: {
    enviar (event) {
      event.preventDefault()

      var config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }

      if (this.$data.dados.name === '' || this.$data.dados.email === '' || this.$data.dados.mensagem === '') {
        this.$data.titulo = 'Warning'
        this.$data.mensagem = 'All fields are required ;)'
        this.$data.btnokvisible = false
        this.executa()
        return
      }

      var er = /^[a-zA-Z0-9][a-zA-Z0-9._-]+@([a-zA-Z0-9._-]+.)[a-zA-Z-0-9]{2}/
      if (!er.exec(this.$data.dados.email)) {
        this.$data.titulo = 'Warning'
        this.$data.mensagem = 'E-mail format is incorrect :('
        this.$data.btnokvisible = false
        this.executa()
        return
      }
      this.loader({visible: true})
      var dados = 'dados=' + JSON.stringify(this.$data.dados)
      this.$http.post('/email', dados, config).then((response) => {
        this.$data.titulo = 'Message was sent!'
        this.$data.mensagem = 'I\'ll contact you soon. :)'
        this.$data.btnokvisible = false
        this.executa()
        this.$data.dados = {}
        this.loader({visible: false})
      }, (response) => {
        this.$data.titulo = 'Error sending'
        this.$data.mensagem = 'Try again, please :('
        this.$data.btnokvisible = false
        this.executa()
        this.loader({ visible: false })
      })
    },
    executa () {
      let data = JSON.parse(JSON.stringify(this.$data))

      this.$store.commit('ATUALIZA_MODAL', data)
      jQuery('#modal1').modal('open')

      setTimeout(function () {
        jQuery('#modal1').modal('close')
      }, 1500)
    },
    loader (data) {
      this.$store.commit('UPDATE_LOADER', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// jm-f-contact.vue?367e23b4